module.exports = __webpack_public_path__ + "img/teacher.5ded1ff2.svg";